import { Button, Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import ProfileBloc from "../../../../bloc/profile_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import App_header from "../../../component/app_header/app_header";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import Base_screen from "../../base/base_screen/base_screen";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppSteps from "../../../component/app_steps/app_steps";
import AppModal from "../../../component/app_modal/app_modal";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import { ReactComponent as EmailIcon } from "../../../../Email.svg";
import { ReactComponent as MessageIcon } from "../../../../Message.svg";
import ProposalBloc from "../../../../bloc/mrtt_proposal_bloc";

class ReviewDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.productIllContainerRef = React.createRef();
        this.productIllContentRef = React.createRef();
        this.proposalContainerRef = React.createRef();
        this.proposalContentRef = React.createRef();
        this.privacyContainerRef = React.createRef();
        this.privacyContentRef = React.createRef();
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            productIllustrationScrollable: false,
            proposalScrollable: false,
            privacyPolicyScrollable: false,
            isDeclarationChecked: false,
            isTermConditionReviewed: false,
            isProductIllustrationReviewed: false,
            isProposalReviewed: false,
            isPrivacyPolicyReviewed: false,
            OTPChannel: null, // 1 -> email, 2 -> sms
            OTPOpen: false,
            qrContent: '',
            isResend: false,
            stepHeader: [
                {
                    title: 'Provide Details',
                    status: 'process'
                },
                {
                    title: 'Upload Documents',
                    status: 'process'
                },
                {
                    title: 'Review',
                    status: 'process'
                },
                {
                    title: 'Consent and Declaration',
                    status: 'process'
                },
            ],
        };
    }

    getProposalId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.getFormData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.isProductIllustrationReviewed !== this.state.isProductIllustrationReviewed ||
            prevState.isProposalReviewed !== this.state.isProposalReviewed ||
            prevState.isPrivacyPolicyReviewed !== this.state.isPrivacyPolicyReviewed
        ) {
            if (
                this.state.isProductIllustrationReviewed &&
                this.state.isProposalReviewed &&
                this.state.isPrivacyPolicyReviewed &&
                !this.state.isTermConditionReviewed
            ) {
                this.setState({ isTermConditionReviewed: true });
            }
        }
    }

    async getFormData() {
        this.setState({ loading: true });
        let editable = await ProposalBloc.editGeneratedProposal(this.getProposalId());
        if (editable.success) {
            let consentDeclarationData = await ProposalBloc.getFormDetailProposal(this.getProposalId(), Config.formProposalDetailMapping[9].category);
            if (consentDeclarationData.success) {
                this.setState({
                    isDeclarationChecked: consentDeclarationData?.data && consentDeclarationData?.data[0]?.proposal_attr.properties?.saDeclaration == 'Yes' ? true : false,
                    isTermConditionReviewed: consentDeclarationData?.data && consentDeclarationData?.data[0]?.proposal_attr.properties?.readConfirm == 'Yes' ? true : false,
                });
            }
        } else {
            this.setState({
                isOpen: true,
                title: 'Notification',
                description: 'This proposal cannot be edit or update.'
            })
        }
        this.setState({ loading: false });
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    handleIsDeclarationChecked = (val) => {
        this.setState({ isDeclarationChecked: val })
    }

    handleIsTermsConditionChecked = (val) => {
        this.setState({ isTermConditionReviewed: val })
    }

    handleGoBackStep = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_review}/${this.getProposalId()}`
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    handleGoProposalDetails = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${this.getProposalId()}`
    }

    async handleSaveCurrentStep() {
        let submitProgress = await this.handleSubmitConsentDeclaration();
        if (submitProgress) {
            this.handleStopWithoutSaving();
        }
    }

    async handleNextStep() {
        let submitProgress = await this.handleSubmitConsentDeclaration();
        if (submitProgress) {
            this.handleSelectOTPModalOpen();
        }
        // window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${this.getProposalId()}`;
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleSelectOTPModalOpen = () => {
        this.setState({ OTPOpen: true })
    }
    handleSelectOTPModalClose = () => {
        this.setState({ OTPOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleOpenProductIllustration = () => {
        this.setState({ productIllustrationOpen: true });
    }
    handleOpenProposal = () => {
        this.setState({ proposalConsentOpen: true });
    }
    handleOpenPrivacy = () => {
        this.setState({ privacyPolicyOpen: true });
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop >= e.target.clientHeight;
        if (bottom) {
            this.state.productIllustrationOpen ? this.setState({ isProductIllustrationReviewed: true }) : this.state.proposalConsentOpen ? this.setState({ isProposalReviewed: true }) : this.setState({ isPrivacyPolicyReviewed: true });
        }
    }

    async handleSendForReview() {
        this.setState({ loading: true, OTPOpen: false });
        let reviewResult = await ProposalBloc.submitForReview(this.getProposalId(), this.state.OTPChannel, this.state.isResend);
        if (reviewResult.success) {
            this.setState({ qrContent: 'data:application/jpg;base64,' + reviewResult.data.qrCode }, () => this.handleQRModalOpen());
        } else {
            this.setState({
                isOpen: true,
                title: 'Error',
                description: reviewResult.message
            })
        }
        this.setState({ loading: false, isResend: true });
        return true;
    }

    async handleSubmitConsentDeclaration() {
        this.setState({ loading: true });
        let payload = {
            saDeclaration: this.state.isDeclarationChecked == true ? "Yes" : "No",
            readConfirm: this.state.isTermConditionReviewed == true ? "Yes" : "No"
        }
        let result = await ProposalBloc.saveFormProposal(this.getProposalId(), Config.formProposalDetailMapping[9].category, payload);
        if (result.success) {
            this.setState({ loading: false });
            return true;
        } else {
            this.setState({
                loading: false,
                title: 'Error',
                description: 'Failed to submit the form.',
                isOpen: true
            })
        }
    }

    handleQRModalOpen = () => {
        this.setState({ QRCodeOpen: true })
    }
    handleQRModalClose = () => {
        this.setState({ QRCodeOpen: false })
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={this.state.isTermConditionReviewed && this.state.isDeclarationChecked}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Send for Review'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                // handleModalClose={() => this.handleMessageModalClose()}
                width={'50%'}
                title={this.state.title}
                subtitle={this.state.description}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.handleStopWithoutSaving()}
                closable={false}
            />
        )
    }

    discardChangesModal = () => {
        return (
            <AppModal
                open={this.state.isDiscardModalOpen}
                handleModalClose={this.handleDiscardModalClose}
                width={'50%'}
                title={'Do you want to discard?'}
                subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                negativeButtonText={'Stop without Saving'}
                positiveButtonText={'Save & Close'}
                handleNegativePress={this.handleStopWithoutSaving}
                handlePositivePress={this.handleSaveCurrentStep}
                closable={false}
            />
        )
    }

    saveAndCloseModal = () => {
        return (
            <AppModal
                open={this.state.isSaveModalOpen}
                handleModalClose={this.handleSaveModalClose}
                width={'50%'}
                title={'Do you want to stop?'}
                subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                negativeButtonText={'Stop without Saving'}
                positiveButtonText={'Save & Close'}
                handleNegativePress={() => this.handleStopWithoutSaving()}
                handlePositivePress={() => this.handleSaveCurrentStep()}
                closable={false}
            />
        )
    }

    qrModal() {
        return (
            <AppModal
                open={this.state.QRCodeOpen}
                handleModalClose={() => this.handleGoProposalDetails()}
                width={'40%'}
                title={'Scan QR Code'}
                subtitle={'Scan QR Code to review proposal'}
                closable={false}
            >
                <div className="w-100 d-flex justify-content-center mt-3">
                    <img className="img-fluid" style={{ objectFit: "cover" }}
                        src={this.state.qrContent}
                    />
                    {/* <QRCode value="https://www.npmjs.com/package/react-qr-code" /> */}
                </div>
            </AppModal>
        )
    }

    otpModal() {
        return (
            <AppModal
                open={this.state.OTPOpen}
                handleModalClose={() => this.handleSelectOTPModalOpen()}
                width={'50%'}
                title={'How do you want to send the OTP?'}
                negativeButtonText={'Cancel'}
                positiveButtonText={'Update'}
                handleNegativePress={() => this.handleSelectOTPModalClose()}
                handlePositivePress={() => this.handleSendForReview()}
                closable={false}
            >
                <div className="mt-2 otp_content_text">
                    <span style={{ color: '#171725' }}>Select OTP Channel <span style={{ color: 'red' }}>*</span></span>
                    <div className="mt-3 d-flex row mx-1">
                        <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '50%',
                                height: '48px',
                                borderRadius: 0,
                                boxShadow: 'none',
                                borderColor: this.state.OTPChannel == '1' ? '#EE7623' : '#D9D9D9',
                                color: this.state.OTPChannel == '1' ? 'white' : 'black',
                                backgroundColor: this.state.OTPChannel == '1' ? '#EE7623' : '#FFFFFF'
                            }}
                            onClick={() => this.setState({ OTPChannel: '1' })}
                        >
                            <EmailIcon className="mr-2" fill={this.state.OTPChannel == '1' ? 'white' : '#92929D'} />
                            Email
                        </Button>
                        <Button
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '50%',
                                height: '48px',
                                borderRadius: 0,
                                boxShadow: 'none',
                                borderColor: this.state.OTPChannel == '2' ? '#EE7623' : '#D9D9D9',
                                color: this.state.OTPChannel == '2' ? '#FFFFFF' : '#000000',
                                backgroundColor: this.state.OTPChannel == '2' ? '#EE7623' : '#FFFFFF'
                            }}
                            onClick={() => this.setState({ OTPChannel: '2' })}
                        >
                            <MessageIcon className="mr-2" fill={this.state.OTPChannel == '2' ? 'white' : '#92929D'} />SMS
                        </Button>
                    </div>
                </div>

            </AppModal>
        )
    }

    renderProductIllustrationContent = () => {
        let height = this.productIllContentRef?.current?.offsetHeight - 50;
        return (
            <>
                <div className="mt-4 px-3" style={{ height: `30vh`, overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.productIllContainerRef}>
                    <div ref={this.productIllContentRef} style={{ height: '40vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Product Illustration</span>
                        </div>
                        <div className='p-3'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
                        </div>
                    </div>
                </div>
            </>
        )
    }
    renderProposalConsentContent = () => {
        return (
            <>
                <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.proposalContainerRef}>
                    <div ref={this.proposalContentRef} style={{ height: '40vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Proposal</span>
                        </div>
                        <div className='p-3'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
                        </div>
                    </div>
                </div>
            </>
        )
    }
    renderPrivacyPolicyContent = () => {
        return (
            <>
                <div className="mt-4 px-3" style={{ height: '30vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.privacyContainerRef}>
                    <div ref={this.privacyContentRef} style={{ height: '40vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Privacy Policy Summary</span>
                        </div>
                        <div className='p-3'>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
                        </div>
                    </div>
                </div>
            </>
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={this.state.stepHeader}
                                />
                            </div>

                        </App_header>
                        {this.state.loading && this.loadingContent()}
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150,
                            }}
                        >
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={Config.proposal.formStepData[3].header}
                                    description={Config.proposal.formStepData[3].subheader}
                                    handleBack={() => this.handleGoBackStep()}
                                />
                            </div>
                            <div className="w-100 my-2 d-flex row" >
                                <div className="w-100 px-3 mt-4 d-flex row justifu-content-between" style={{ fontFamily: 'Lato' }}>
                                    <div className="w-100">
                                        <div className="consent_declaration_container px-4">
                                            <Checkbox
                                                checked={this.state.isDeclarationChecked}
                                                onChange={(e) => this.handleIsDeclarationChecked(e.target.checked)}
                                            >
                                                <span className="consent_declaration_header">Sales Representative{'\''}s Declaration</span>
                                            </Checkbox>
                                            <div>I hereby declare and confirm that: </div>
                                            <ol className="consent_declaration_text mt-4 ml-3">
                                                <li className="my-2">
                                                    All the information contained in this application form is the only information given to me by the applicant and/or person to be covered and I have not withheld any other information which might influence the acceptance of this application by FWD Takaful;
                                                </li>
                                                <li className="my-2">
                                                    I have not made any statement, representation or promise to the applicant and/or person to be covered which is contrary to and/or misrepresents the terms of the Takaful Certificate, and/or to any relevant and applicable laws and standards that govern Takaful intermediaries’ activity. I have not acted or conducted myself in such a way that amounts to misrepresenting the terms of the Takaful Certificate;
                                                </li>
                                                <li className="my-2">
                                                    I have disclosed the essential information in connection with the Takaful plan as required under Malaysian laws and regulations, to the satisfaction of the applicant; and
                                                </li>
                                                <li className="my-2">
                                                    Pursuant to the Anti-Money Laundering, Anti-Terrorism Financing and Proceeds of Unlawful Activities Act 2001, I confirm that where the person is an individual, I have sighted the original MyKad/valid passport and verified the identity of the proposed person covered/applicant; or if other than an individual person, I have sighted the original constituent and identification documents; and have verified the beneficial owners and details of the proposed person covered/applicant.
                                                </li>
                                            </ol>
                                        </div>
                                        <div className="consent_declaration_container mt-3 px-4">
                                            <span className="consent_declaration_header">Reminder</span>
                                            <ol className="consent_declaration_text mt-4 ml-3">
                                                <li className="my-2">
                                                    Please ensure that customer(s) have reviewed all questions and re-verify their health declaration before signing this proposal to avoid any rejection during certificate servicing and claims process (if any).
                                                </li>
                                                <li className="my-2">
                                                    Please ensure that you have clearly explained about the product benefits, general exclusion of this product and its riders (if any).
                                                </li>
                                                <li className="my-2">
                                                    Please ensure that the selected product / riders are meeting customers{'\''} protection / financial needs.
                                                </li>
                                            </ol>

                                        </div>
                                    </div>

                                    <div className="d-flex mt-5">
                                        <Checkbox
                                            checked={this.state.isTermConditionReviewed}
                                            onChange={(e) => this.handleIsTermsConditionChecked(e.target.checked)}
                                        >
                                            I confirm that I have thoroughly read and comprehended all the terms and conditions outlined above, and have also reviewed the
                                            <span className="consent_declaration_color_text" > Product Illustration</span>, <span className="consent_declaration_color_text" >Proposal</span> and <span className="consent_declaration_color_text">Privacy Policy Summary</span>.
                                        </Checkbox>
                                    </div>
                                </div>
                            </div>
                            {this.renderBottomBar()}
                            {this.saveAndCloseModal()}
                            {this.discardChangesModal()}
                            {this.showMessageModal()}
                            {this.otpModal()}
                            {this.qrModal()}
                            <AppModal
                                open={this.state.productIllustrationOpen}
                                handleModalClose={() => this.setState({ productIllustrationOpen: false })}
                                width={'70%'}
                                title={'Terms and Conditions'}
                                subtitle={'Last Updated on 30 Jan 2024'}
                            >
                                {this.renderProductIllustrationContent()}
                            </AppModal>
                            <AppModal
                                open={this.state.proposalConsentOpen}
                                handleModalClose={() => this.setState({ proposalConsentOpen: false })}
                                width={'70%'}
                                title={'Terms and Conditions'}
                                subtitle={'Last Updated on 30 Jan 2024'}
                            >
                                {this.renderProposalConsentContent()}
                            </AppModal>
                            <AppModal
                                open={this.state.privacyPolicyOpen}
                                handleModalClose={() => this.setState({ privacyPolicyOpen: false })}
                                width={'70%'}
                                title={'Terms and Conditions'}
                                subtitle={'Last Updated on 30 Jan 2024'}
                            >
                                {this.renderPrivacyPolicyContent()}
                            </AppModal>
                        </div>
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ReviewDetails));
